import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import questionAnswers from "./questionSet";
import styles from "./styles";
import withStyles from "@material-ui/core/styles/withStyles";
import QuestionScreen from "../../components/QuestionScreen";
import WrongMoveModal from "../../components/WrongMoveModal";
import EvaluatorModal from "../../components/EvaluatorModal";

const QuizScreen = (props) => {
  const { classes, setCurrentScreen, setAnswers, answers, ...others } = props;

  const [questionIndex, setQuestionIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [resetGraph, setResetGraph] = useState(false);
  const [answeredCorrectly, setAnsweredCorrectly] = useState(null);
  const [showTutorial, setShowTutorial] = useState(false);

  const modalOpen = () => setOpen(true);

  const nextQuestion = () => {
    setOpen(false);
    setAnswers([...answers, answeredCorrectly]);
    if (questionIndex >= questionAnswers.length - 1) setCurrentScreen("Result");
    else {
      setQuestionIndex(questionIndex + 1);
    }
  };

  console.log("questionIndex: ", questionIndex);

  return (
    <div className={classes.quizScreenContainer}>
      <QuestionScreen
        {...others}
        questionAnswer={questionAnswers[questionIndex]}
        modalOpen={modalOpen}
        nextQuestion={nextQuestion}
        key={questionIndex}
        questionIndex={questionIndex}
        setAnsweredCorrectly={setAnsweredCorrectly}
      />
      {open && (
        <EvaluatorModal
          answeredCorrectly={answeredCorrectly}
          nextQuestion={nextQuestion}
          question={questionAnswers[questionIndex]}
        />
      )}
    </div>
  );
};

export default withStyles(styles)(QuizScreen);
